import React, { FC } from 'react';
import styles from './ProjectCard.module.css';
import Features from '../Features/Features';
import Button from '../UI/Button/Button';
import Icon from '../Icon';
import { useNavigate } from 'react-router-dom';
import { BUSINESS_PAGE, FLATS_PAGE, PARKING_PAGE } from '../../router/paths';
import cn from 'classnames'

interface ButtonData {
  text: string;
}

interface ProjectCardProps {
  title?: string;
  description: string;
  features: { id: number; text: string; image?: string }[];
  buttons: ButtonData[];
  image?: string;
  preview: string;
  onButtonClick: (buttonText: string) => void;
  projectId: string;
}

const ProjectCard: FC<ProjectCardProps> = ({
  title,
  description,
  features,
  image,
  preview,
  buttons = [],
  projectId
}) => {
  const navigate = useNavigate();

  const handleButtonClick = (buttonText: string) => {
    if (buttonText.includes('квартира') || buttonText.includes('квартиры') || buttonText.includes('квартир')) {
      navigate(FLATS_PAGE);
    } else if (buttonText.includes('машиноместо') || buttonText.includes('машиноместа') || buttonText.includes('машиномест')) {
      navigate(PARKING_PAGE);
    } else if (buttonText.includes('помещение') || buttonText.includes('помещения') || buttonText.includes('помещений')) {
      navigate(BUSINESS_PAGE);
    } else {
      navigate(`/projects/status`);
    }
  };

  return (
    <div
      className={styles.card}
    >
      <div className={styles.inner}>
        <div className={styles.main_wrapper}>
          <img src={preview} className={styles.preview_image} alt='Изображение проекта' />
          <Features features={features} alignment="side" cardColor="black" />
          <div className={styles.header_wrapper}>
            {image ? (
              <img src={image} alt={title || description} className={styles.logo_title} />
            ) : (
              title && <h2 className={styles.title}>{title}</h2>
            )}
            <p className={cn('text_body_b1', styles.description)}>{description}</p>
            <div className={styles.all_buttons_wrapper}>
              <Button
                colorType="bw"
                roundType="small_rounded"
                icon={
                  <Icon name="iconMoreInfo" width="16" height="16" fill="#fff" />
                }
                onClick={() => handleButtonClick('Страница проекта')}
                width='fit-content'
              >
                Страница проекта
              </Button>
              <div className={styles.button_wrapper}>
                {buttons.map((button, index) => (
                  <Button
                    key={index}
                    colorType="bw"
                    roundType="small_rounded"
                    icon={
                      <Icon name="iconMoreInfo" width="16" height="16" fill="#fff" />
                    }
                    onClick={() => handleButtonClick(button.text)}
                    width='fit-content'
                  >
                    {button.text}
                  </Button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;